import React from "react";

const Skeleton = ({
  width = "100%",
  height = "20px",
  color = "#e9ecef",
  className = "",
}) => {
  return (
    <>
      <style>
        {`
          .custom-skeleton {
            position: relative;
            overflow: hidden;
            display: inline-block;
          }

          .custom-skeleton::after {
            content: "";
            position: absolute;
            top: 0;
            left: -150%;
            height: 100%;
            width: 150%;
            background: linear-gradient(
              90deg,
              rgba(255, 255, 255, 0) 0%,
              rgba(255, 255, 255, 0.6) 50%,
              rgba(255, 255, 255, 0) 100%
            );
            animation: shimmer 1.4s infinite;
          }

          @keyframes shimmer {
            100% {
              left: 100%;
            }
          }
        `}
      </style>

      <div
        className={`custom-skeleton ${className}`}
        style={{
          width,
          height,
          backgroundColor: color,
        }}
      />
    </>
  );
};

export default Skeleton;